module.exports = __webpack_public_path__ + "images/sprites/ui/circle_arrow_wh_f92795d10c4c81acfdef7ed1260d2959.png";